// ------------------------------------
// Imports
// ------------------------------------
import {
  FETCH_USER, ERROR_USER,
  UPDATE_USER, USER_LOGOUT,
  UPDATE_USER_EMAIL,
  SET_PUBLIC_ACCESSIBLE,
  RESET_USER,
  FETCH_USER_SUBSCRIPTIONS, UPDATE_USER_SUBSCRIPTIONS, ERROR_USER_SUBSCRIPTIONS,
  UPDATE_USER_INTRO_ELIGIBILITY, ERROR_USER_INTRO_ELIGIBILITY
} from 'redux/actions/auth';

// ------------------------------------
// Reducer Handlers
// ------------------------------------
export const initialState = {
  isFetching: false,
  isFetchingSubscriptions: false,
  isError: false,
  info: null,
  isPublicAccessible: false
};

const REDUCER_HANDLERS = {
  [RESET_USER]: (state, action) => ({ ...state }),
  [FETCH_USER]: (state, action) => ({ ...state, isFetching: true }),
  [FETCH_USER_SUBSCRIPTIONS]: (state, action) => ({ ...state, info: { ...state.info }, isFetchingSubscriptions: true }),
  [UPDATE_USER]: (state, action) => ({ ...state, isFetching: false, info: { ...state.info, user: action.payload } }),
  [UPDATE_USER_EMAIL]: (state, action) => ({ ...state, info: { ...state.info, user: { ...state.info.user, ...action.payload } } }),
  [ERROR_USER]: () => ({ ...initialState, isError: true }),
  [UPDATE_USER_SUBSCRIPTIONS]: (state, action) => ({ ...state, isFetchingSubscriptions: false, info: { ...state.info, ...action.payload } }),
  [ERROR_USER_SUBSCRIPTIONS]: (state, action) => ({ ...state, isError: true }),
  [UPDATE_USER_INTRO_ELIGIBILITY]: (state, action) => ({ ...state, info: { ...state.info, user: { ...state.info.user, ...action.payload } } }),
  [ERROR_USER_INTRO_ELIGIBILITY]: (state, action) => ({ ...state, isError: true }),
  [SET_PUBLIC_ACCESSIBLE]: (state, action) => ({ ...state, isPublicAccessible: true })
};

export function checkLogout(state, action) {
  let appState = state;
  if (action.type === USER_LOGOUT) {
    appState = undefined;
  }
  return appState;
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function authReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js